import React, { useState } from "react";
import { Avatar, Modal } from "antd";
import { Session } from "../../../../business";
import { baseUrl } from "../../../../constants/enviroment";

interface AvatarSelectProps {
    image: string | null;
    size: "small" | "large" | "default";
    fromLabel: boolean;
    isEmployee?: boolean;
}
export function SelectAvatar({ image, size = "default", fromLabel = false, isEmployee = false }: AvatarSelectProps) {
    const action = isEmployee ? "foto_colaborador" : "ficheiro";
    const src = `${baseUrl}/Gestor/geredocumentos.php?accao=${action}&ficheiro=${image}&token=Bearer%20${Session.getToken()}`;

    const [previewImage, setPreviewImage] = useState(false);

    function handleCancelPreviewImage() {
        setPreviewImage(false);
    }

    return (
        <>
            {image && src ? (
                fromLabel ? (
                    <div
                        onClick={(event) => {
                            if (image) {
                                event.preventDefault();
                                event.stopPropagation();
                                setPreviewImage(true);
                            }
                        }}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                        }}
                    >
                        <Avatar src={src} style={{ marginRight: 6 }} size={size} />
                    </div>
                ) : (
                    <Avatar src={src} style={{ marginRight: 6 }} size={size}></Avatar>
                )
            ) : (
                <Avatar style={{ marginRight: 6 }} icon="user" size={size} />
            )}

            {previewImage && src && (
                <Modal visible footer={null} onCancel={handleCancelPreviewImage}>
                    <img alt="" style={{ width: "100%" }} src={src} />
                </Modal>
            )}
        </>
    );
}
